document.addEventListener("DOMContentLoaded", () => {
  const slides = document.querySelectorAll(".hero-slide");
  const dots = document.querySelectorAll(".dot");
  const nextBtn = document.querySelector(".next-btn");
  const prevBtn = document.querySelector(".prev-btn");

  let index = 0;

  function showSlide(i) {
    slides.forEach(slide => slide.classList.remove("active"));
    dots.forEach(dot => dot.classList.remove("active"));

    slides[i].classList.add("active");
    dots[i].classList.add("active");
    index = i;
  }

  function nextSlide() {
    index = (index + 1) % slides.length;
    showSlide(index);
  }

  function prevSlide() {
    index = (index - 1 + slides.length) % slides.length;
    showSlide(index);
  }

  // Init
  showSlide(0);

  // Autoplay every 5s
  let autoplay = setInterval(nextSlide, 5000);

  // Buttons
  nextBtn.addEventListener("click", () => {
    nextSlide();
    clearInterval(autoplay);
  });

  prevBtn.addEventListener("click", () => {
    prevSlide();
    clearInterval(autoplay);
  });

  // Dots click
  dots.forEach(dot => {
    dot.addEventListener("click", () => {
      showSlide(parseInt(dot.dataset.index));
      clearInterval(autoplay);
    });
  });
});